export default "__VITE_ASSET__B1kZo42C__"